module.exports = __webpack_public_path__ + "static/img/logo.9a43f6f3.png";